import { localMode, localAccountPath } from "@/transport/local-mode"
import { requestFetch } from "@/transport/http"
import { userSessionHeaders } from "@/storage/user-session"

function trimTrailingSlash(value: string) {
  return value.replace(/\/+$/, "")
}

export function controlApiBasicAuthorization(username?: string, password?: string) {
  if (!password) return
  return `Basic ${btoa(`${username?.trim() || "mux"}:${password}`)}`
}

type ControlApiCredentialEnv = {
  VITE_MUX_SERVER_USERNAME?: string
  VITE_MUX_SERVER_PASSWORD?: string
}

export function configuredControlApiCredentials(env: ControlApiCredentialEnv = import.meta.env as ControlApiCredentialEnv) {
  const password = env.VITE_MUX_SERVER_PASSWORD?.trim() || undefined
  const username = env.VITE_MUX_SERVER_USERNAME?.trim() || (password ? "mux" : undefined)
  return { username, password }
}

export function resolveControlApiBase(configured: string | undefined, origin: string) {
  const value = configured?.trim()
  if (!value) return origin
  try {
    const url = new URL(value)
    if (url.protocol !== "http:" && url.protocol !== "https:") return origin
    return trimTrailingSlash(url.toString())
  } catch {
    return origin
  }
}

export function controlApiUrl(path = "") {
  const base = localMode() ? location.origin : resolveControlApiBase(import.meta.env.VITE_MUX_CONTROL_API_URL, location.origin)
  if (!path) return base
  return `${base}${path.startsWith("/") ? path : `/${path}`}`
}

export async function controlApiFetch(path: string, init?: RequestInit) {
  if (localMode()) return requestFetch(controlApiUrl(localAccountPath(path)), { ...init, credentials: "same-origin" })
  const headers = new Headers(init?.headers || {})
  const credentials = configuredControlApiCredentials()
  const basic = controlApiBasicAuthorization(credentials.username, credentials.password)
  if (basic && !headers.has("Authorization")) headers.set("Authorization", basic)
  for (const [key, value] of Object.entries(userSessionHeaders())) {
    if (!headers.has(key)) headers.set(key, value)
  }
  return requestFetch(controlApiUrl(path), {
    ...init,
    headers,
    credentials: "include",
  })
}
